// extracted by mini-css-extract-plugin
export default {"chatUsers":"UserChats_chatUsers__jN0g-"};